export default __webpack_public_path__ + "static/media/branding-bolditalic-webfont.c64aa750.woff";